<template>
  <div>
    <section class="hc-geo is-loaded">
      <section class="hc-geo__region is-active">
        <header class="hc-hero-secondary hc-hero-secondary__bg hc-section header_bg hc_container_mobile_np">
          <div class="hc-hero-secondary__body bg-offwhite-100">
            <AnimationTextBg divClass="hc-hero-secondary"></AnimationTextBg>
            <div class="hc-hero-secondary__left">
              <div class="hc-hero-secondary__breadcrumbs">
                <span>
                  <router-link to="/home">{{ $t('router.home') }}</router-link>
                </span>
                <span> {{ $t('router.lifeAtHilton') }} </span>
              </div>
              <div class="has-eyebrow-font-size">{{ $t('router.lifeAtHilton') }}</div>
              <h1 class="wp-block-heading hc-hero-secondary__title has-t-disp-2-font-size">
                {{ $t('lifeAtHilton.bigTitle') }}
              </h1>
              <p class="hc-hero-secondary__description has-md-font-size">
                {{ $t('lifeAtHilton.titleDesc1') }}
                <br /><br />
                {{ $t('lifeAtHilton.titleDesc2') }}
              </p>
            </div>
            <div class="hc-hero-secondary__right header-img">
              <figure class="wp-block-image aligncenter size-full hc-hero-secondary__right-img">
                <img :src="chinese_woman_serves_tea" alt="" />
                <figcaption class="wp-element-caption">
                  {{ $t('lifeAtHilton.titleLocation') }}
                </figcaption>
              </figure>
            </div>
          </div>
        </header>
      </section>
    </section>
    <!-- 希有故事 -->
    <section class="hc-geo is-loaded">
      <section class="hc-geo__region is-active">
        <section class="hc-section bg-darkblue hc_container_mobile_np">
          <SectionTextureBg v-if="device === 'pc'" position="center" />
          <div class="story-list__body ">
            <section class="hc-static-testimonial hc-static-testimonial__container hc-variation--33-33-33">
              <h2 class="wp-block-heading hc-static-testimonial__title t-disp-3 t-darkblue">
                {{ $t('whyHilton') }}
              </h2>
              <div class="story-list" v-if="device === 'pc'">
                <div class="story-item" v-for="(story, index) in storyList" :key="index">
                  <img class="video-img" :src="story.imgUrl" alt="" @click="changePlayVideo(story)">
                  <div class="story-bottom">
                    <div class="story-body">
                      <h4 class="story-title">
                        {{ story.title }}
                      </h4>
                      <p class="story-desc">
                        {{ story.desc }}
                      </p>
                    </div>
                    <div class="story-address">
                      {{ story.address }}
                    </div>
                  </div>
                </div>
                <div class="story-item">
                </div>
              </div>
              <div class="hc-3up-bucket__list_mobile" v-else>
                <Swipe class="my-swipe" @change="onChange" :autoplay="0" :loop="false" :initial-swipe="0" :width="324"
                  :height="435" :show-indicators="false" indicator-color="#1989fa">
                  <swipe-item class="my-swipe-item" v-for="(story, index) in storyList" :key="index">
                    <div class="story-item">
                      <video ref="videoRef" width="304" height="200" class="video-img" :poster="story.imgUrl" controls
                        :src="story.video">
                        <track kind="captions" src="data:text/vtt;base64," srclang="en" label="No captions">
                      </video>
                      <div class="story-bottom">
                        <div class="story-body">
                          <h4 class="story-title">
                            {{ story.title }}
                          </h4>
                          <p class="story-desc">
                            {{ story.desc }}
                          </p>
                        </div>
                        <div class="story-address">
                          {{ story.address }}
                        </div>
                      </div>
                    </div>
                  </swipe-item>
                </Swipe>
                <div class="custom-indicators">
                  <div v-for="index in storyList.length" :key="index" :class="{ active: currentIndex === index - 1 }">
                  </div>
                </div>
              </div>
            </section>
          </div>

        </section>
      </section>
    </section>
    <section class="hc-geo is-loaded">
      <section class="hc-geo__region is-active">
        <section class="hc-section bg-offwhite-200">
          <div class="hc-cntr">
            <section class="hc-text-image-5050">
              <figure class="wp-block-image size-large hc-text-image-5050__image">
                <img :src="chinese_woman_concierge_server" alt="" />
              </figure>
              <div class="hc-text-image-5050__content">
                <h2 class="wp-block-heading hc-text-image-5050__header has-t-disp-3-font-size">
                  {{ $t('lifeAtHilton.growth') }}
                </h2>
                <p class="hc-text-image-5050__subcopy has-lg-font-size">
                  {{ $t('lifeAtHilton.growthDesc') }}
                </p>
                <CommonButton buttonType="primary-action" :clickHandle="goSearchJob" :buttonText="$t('searchjobs')" />
              </div>
            </section>
          </div>
        </section>
      </section>
    </section>
    <VideoPlay :show="showVideo" :videoUrl="playVideo" :posterUrl="posterUrl" @closeVideo="closeVideoHandle">
    </VideoPlay>
  </div>
</template>

<script setup>
import chinese_woman_serves_tea from "@/assets/image/lifeAtHilton/chinese-woman-serves-tea.jpg";
import chinese_woman_concierge_server from "@/assets/image/lifeAtHilton/chinese-woman-concierge-server.png";
import video0 from '@/assets/image/lifeAtHilton/video0.jpg'
import video1 from '@/assets/image/lifeAtHilton/video1.jpg'
import video2 from '@/assets/image/lifeAtHilton/video2.jpg'
import video3 from '@/assets/image/lifeAtHilton/video3.jpg'
import video4 from '@/assets/image/lifeAtHilton/video4.jpg'
import video5 from '@/assets/image/lifeAtHilton/video5.jpg'
import AnimationTextBg from "@/components/AnimationTextBg.vue";
import CommonButton from "@/components/CommonButton.vue";
import SectionTextureBg from "@/components/SectionTextureBg.vue";
import VideoPlay from "@/components/VideoPlay.vue";
import { ref, computed, inject } from 'vue'
import { useRouter } from "vue-router";
import { Swipe, SwipeItem } from "vant";
import { useI18n } from "vue-i18n";
const videop0 = '/videos/video-p0.mp4'
const videop1 = '/videos/video-p1.mp4'
const videop2 = '/videos/video-p2.mp4'
const videop3 = '/videos/video-p3.mp4'
const videop4 = '/videos/video-p4.mp4'
const videop5 = '/videos/video-p5.mp4'
const { t, locale } = useI18n();
const device = inject("device");
const router = useRouter();

const storyList = computed(() => {
  return [
    {
      imgUrl: video0,
      video: videop0,
      title: t('lifeAtHilton.storyTitle0'),
      desc: t('lifeAtHilton.storyDesc0'),
      address: t('lifeAtHilton.storyAddress0')
    },
    {
      imgUrl: video1,
      video: videop1,
      title: t('lifeAtHilton.storyTitle1'),
      desc: t('lifeAtHilton.storyDesc1'),
      address: t('lifeAtHilton.storyAddress1')
    },
    {
      imgUrl: video4,
      video: videop4,
      title: t('lifeAtHilton.storyTitle4'),
      desc: t('lifeAtHilton.storyDesc4'),
      address: t('lifeAtHilton.storyAddress4')
    },
    {
      imgUrl: video2,
      video: videop2,
      title: t('lifeAtHilton.storyTitle2'),
      desc: t('lifeAtHilton.storyDesc2'),
      address: t('lifeAtHilton.storyAddress2')
    },
    {
      imgUrl: video3,
      video: videop3,
      title: t('lifeAtHilton.storyTitle3'),
      desc: t('lifeAtHilton.storyDesc3'),
      address: t('lifeAtHilton.storyAddress3')
    },

    {
      imgUrl: video5,
      video: videop5,
      title: t('lifeAtHilton.storyTitle5'),
      desc: t('lifeAtHilton.storyDesc5'),
      address: t('lifeAtHilton.storyAddress5')
    }
  ]
})
const showVideo = ref(false)
const playVideo = ref('')
const posterUrl = ref('')
const changePlayVideo = (item) => {
  showVideo.value = true
  playVideo.value = item.video
  posterUrl.value = item.imgUrl
}
const closeVideoHandle = () => {
  showVideo.value = false
  playVideo.value = null
  posterUrl.value = null
}

// 自定义轮播图指示器
const currentIndex = ref(0);
const onChange = (index) => {
  currentIndex.value = index;
};
const goSearchJob = () => {
  router.push({
    path: "/searchJob",
  });
}
</script>
<style lang="scss" scoped>
.header-img {
  z-index: 1;
  justify-content: center;
  padding-top: 30px;
  padding-bottom: 30px;

  .hc-hero-secondary__right-img {
    padding: 16px;
    border-radius: 9999px 9999px 0 0;
            background-image: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.2) 100%);
    margin-right: -11px;
  }
}

.has-t-disp-2-font-size {
  width: 84%;
  font-weight: 400;
  font-size: 4rem;
  line-height: 4.5rem;
}

.hc-static-testimonial__title {
  font-weight: 400;
}

.header_bg {
  background-image: url('/src/assets/image/secondary-hero-bg.webp');
}

.t-disp-3 {
  color: var(--hc-color--darkblue);
  margin-left: 0;
}

.story-list__body {
  position: relative;
  padding: 44px 44px 0 44px;
  max-width: 1426px;
  margin: 0 auto;
  gap: 44px;
  overflow: hidden;
  background-color: var(--hc-color--offwhite-100);
}

.story-list {
  display: flex;
  justify-content: space-around;
  gap: 48px 24px;
  margin-top: 80px;
  flex-wrap: wrap;

  .story-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 448px;

    .video-img {
      cursor: pointer;
    }

    img {
      width: 100%;
    }

    .story-bottom {
      padding: 24px;
      background-color: #fff;
      flex: 1;
      display: flex;
      flex-direction: column;

      .story-body {
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        margin-bottom: 16px;
        flex: 1;

        .story-title {
          color: var(--hc-color--darkblue);
          font-size: 1.75rem;
          font-weight: 400;
          font-family: var(--hc-font--headline);
        }

        .story-desc {
          font-size: 1rem;
          padding-top: 12px;
          padding-bottom: 24px;
        }
      }
    }

    .story-address {
      color: rgba(0, 0, 0, 1);
      font-size: 0.85rem;
    }
  }
}

.hc-text-image-5050__header {
  font-weight: 400;
}

.hc-3up-bucket__list_mobile {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding-bottom: 30px;

  .my-swipe {
    .my-swipe-item {
      padding: 0 10px;
      display: flex;

      .story-item {
        width: 320px;
        display: flex;
        flex-direction: column;

        .video-img {
          cursor: pointer;
        }

        img {
          width: 100%;
        }

        .story-bottom {
          padding: 16px 20px 20px 20px;
          background-color: #fff;
          flex: 1;
          display: flex;
          flex-direction: column;

          .story-body {
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            margin-bottom: 16px;
            flex: 1;

            .story-title {
              color: var(--hc-color--darkblue);
              font-size: 1.14285rem;
              font-weight: 400;
              font-family: var(--hc-font--headline);
            }

            .story-desc {
              font-size: 0.857rem;
              padding-top: 12px;
              padding-bottom: 24px;
            }
          }

          .story-address {
            font-size: 0.857rem;
            color: rgba(0, 0, 0, 1);
          }
        }
      }
    }
  }

  .custom-indicators {
    position: absolute;
    bottom: 0px;
    /* 将指示器放在轮播图下方 */
    left: 50%;
    transform: translateX(-50%);
    display: flex;

    div {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #FFF;
      margin: 0 4px;
    }

    div.active {
      background: #C028B9;
    }
  }
}

     .hc-hero-secondary__description {
       margin-bottom: 0px;
     }
@media (max-width: 767px) {
  .hc-hero-secondary__breadcrumbs {
    display: none;
  }

  .header_bg {
    background-image: unset;
    background-color: rgba(240, 233, 230, 1);
  }

  .hc-hero-secondary__body {
    background: linear-gradient(180deg,
        rgba(240, 233, 230, 1) 0%,
        rgba(240, 233, 230, 0.2) 100%);
  }

  .has-t-disp-2-font-size {
    width: 100%;
    font-size: 2.285rem;
    line-height: 2.85rem;
  }

  // 手机端清除padding
  .hc_container_mobile_np {
    padding-inline: 0px !important;
  }

  .story-list__body {
    padding: 32px 0;
    background-color: unset;

    .hc-static-testimonial__container {
      background-color: unset;
      padding: 0;

      .t-disp-3 {
        padding: 0 40px;
        color: #fff;
        font-size: 2.285rem;
        margin-bottom: 32px;
      }
    }
  }

  .hc-text-image-5050__header {
    font-size: 2.285rem;
  }

  .has-lg-font-size {
    font-size: 1rem;
  }
}
</style>